import { api } from './api';

export interface CreateConcordReplayRequest {
  startQueryDate: string;
  endQueryDate: string;
}

export interface CreateConcordReplayResponse {
  jobId: string;
  status: string;
}

export interface ConcordReplayJobSummary {
  jobId: string;
  requestedByEmail: string | null;
  requestedAt: string | null;
  completedAt: string | null;
  status: string;
  startQueryDate: string;
  endQueryDate: string;
  initialFailed: number | null;
  duplicates: number | null;
  succeeded: number | null;
  remainingFailed: number | null;
}

export interface ConcordReplayJobDetail extends ConcordReplayJobSummary {
  logs: string[];
  error: string | null;
}

export const concordReplayApi = api.injectEndpoints({
  endpoints: (build) => ({
    createConcordReplay: build.mutation<CreateConcordReplayResponse, CreateConcordReplayRequest>({
      query: (body) => ({ url: '/admin/concord-replay', method: 'POST', body }),
    }),
    getConcordReplayJobs: build.query<{ jobs: ConcordReplayJobSummary[] }, void>({
      query: () => ({ url: '/admin/concord-replay', method: 'GET' }),
    }),
    getConcordReplayJob: build.query<{ job: ConcordReplayJobDetail }, string>({
      query: (jobId) => ({ url: `/admin/concord-replay/${jobId}`, method: 'GET' }),
    }),
  }),
});

export const { useCreateConcordReplayMutation, useGetConcordReplayJobsQuery, useGetConcordReplayJobQuery } =
  concordReplayApi;
